import { useEffect, useState } from "react";
import http from "@/api";

let _cache = null;

export default function useDeptCounts() {
  const [counts, setCounts] = useState(_cache || {});
  useEffect(() => {
    if (_cache) return;
    http.get("/departments/product-counts")
      .then(({ data }) => { _cache = data; setCounts(data); })
      .catch(() => {});
  }, []);
  return counts;
}
